/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_900, PHONE_900, URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: 'Configurar mi pack',
              link: URLS.PACK_CONFIG,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Lo sentimos, no podemos ofrecerte este producto',
          msg: [
            'Para contratar Netflix necesitas tener un Pack miMovistar y cobertura fibra.',
          ],
          errorName: 'producto incompatible',
        },
      },
      FUSION_MANDATORY: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Lo sentimos, no podemos ofrecerte este producto',
          msg: [
            'Para añadir este producto es necesario contratar un pack miMovistar',
          ],
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Ver productos miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'fusión requerido',
        },
      },
      INCOMPATIBLE_PRODUCT_BY_ZONE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tras revisar tus datos, no podemos ofrecerte este producto',
          msg: [
            'Lo sentimos, para contratar Netflix debes tener contratado miMovistar o Fusión',
          ],
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Configurar miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con zona',
        },
      },
      BUY_ALREADY_DONE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Estás solicitando el alta de un producto que ya tienes contratado.',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Upss… algo ha ido mal",
          msg: [
            "Se ha producido un error al generar tu pedido.",
            `Por favor, reinténtalo más tarde o llámanos gratis al ${PHONE_900} para que podamos gestionarlo.`,
            "Sentimos las molestias.",
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "error generico",
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
